import { useState } from 'react'

import formBackground from '../assets/SETCStartingForm/formBackground.png'
import taxForm from '../assets/SETCStartingForm/taxForm.png'
import heartForm from '../assets/SETCStartingForm/heartForm.png'
import peopleForm from '../assets/SETCStartingForm/peopleForm.png'
import stopForm from '../assets/SETCStartingForm/stopForm.png'
import moneyForm from '../assets/SETCStartingForm/moneyForm.png'
import refundForm from '../assets/SETCStartingForm/refundForm.png'

export default function SETCStartingForm() {
  const [currentPage, setCurrentPage] = useState(0)
  const [taxCredit, setTaxCredit] = useState('')

  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center font-mont'
      style={{
        backgroundImage: `url(${formBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {currentPage === 0 ? (
        <div className='flex flex-col items-center justify-center text-center'>
          <img className='w-28 mb-5' src={taxForm} alt='taxForm' />
          <p className='font-bold text-2xl mb-4'>Alright, let's get started</p>
          <p className='font-bold text-lg mb-4'>Did you file a Schedule SE on your 2021 tax return?</p>
          <div className='flex flex-col sm:flex-row items-center gap-4'>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-32 max-sm:w-32 h-10 rounded-md shadow-full text-white'>YES</button>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-32 max-sm:w-32 h-10 rounded-md shadow-full text-white'>NO</button>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-32 max-sm:w-32 h-10 rounded-md shadow-full text-white'>NOT SURE</button>
          </div>
        </div>
      ) : currentPage === 1 ? (
        <div className='flex flex-col items-center justify-center text-center'>
          <img className='w-28 mb-5' src={heartForm} alt='heartForm' />
          <p className='font-bold text-2xl mb-4'>Question 2/5</p>
          <p className='font-bold text-lg mb-4'>In 2021, did you provide care for a child under 18?</p>
          <p className='mb-4'>Or a son or daughter with a mental or physical disability.</p>
          <div className='flex flex-col sm:flex-row items-center gap-4'>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-60 max-sm:w-64 h-16 rounded-md shadow-full text-white'>
              <p className='font-bold text-lg'>Yes</p>
              <p className='text-sm'>I provided care for a child</p>
            </button>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-60 max-sm:w-64 h-16 rounded-md shadow-full text-white'>
              <p className='font-bold text-lg'>No</p>
              <p className='text-sm'>I did not provide care for a child</p>
            </button>
          </div>
        </div>
      ) : currentPage === 2 ? (
        <div className='flex flex-col items-center justify-center text-center'>
          <img className='w-28 mb-5' src={peopleForm} alt='peopleForm' />
          <p className='font-bold text-2xl mb-4'>Question 3/5</p>
          <p className='font-bold text-lg mb-4'>Were any of your children affected by a COVID-19 related school or daycare shutdown in 2021?</p>
          <div className='flex flex-col sm:flex-row items-center gap-4'>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-32 max-sm:w-32 h-10 rounded-md shadow-full text-white'>YES</button>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-32 max-sm:w-32 h-10 rounded-md shadow-full text-white'>NO</button>
          </div>
        </div>
      ) : currentPage === 3 ? (
        <div className='flex flex-col items-center justify-center text-center max-sm:scale-80'>
          <img className='w-28 mb-5' src={stopForm} alt='stopForm' />
          <p className='font-bold text-2xl mb-4'>Question 4/5</p>
          <p className='font-bold text-lg mb-4'>Was your self-employment interrupted at any time during the COVID-19 pandemic?</p>
          <p className='font-bold text-sm'>Examples may include:</p>
          <ul className='text-left list-disc list-inside text-sm mb-4'>
            <li>You paused work due to possible symptoms and were seeking a medical diagnosis of COVID-19</li>
            <li>You paused work while waiting for the results of a COVID-19 test</li>
            <li>Being unable to work due to an isolation order</li>
            <li>You were advised by a health care provider to self-quarantine</li>
            <li>You took time off from work to get vaccinated</li>
          </ul>
          <div className='flex flex-col sm:flex-row items-center gap-4'>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-44 max-sm:w-44 h-16 rounded-md shadow-full text-white'>
              <p className='font-bold text-lg'>Yes</p>
              <p className='text-sm'>It was interrupted</p>
            </button>
            <button onClick={() => setCurrentPage(currentPage + 1)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-44 max-sm:w-44 h-16 rounded-md shadow-full text-white'>
              <p className='font-bold text-lg'>No</p>
              <p className='text-sm'>It was not interrupted</p>
            </button>
          </div>
        </div>
      ) : currentPage === 4 ? (
        <div className='flex flex-col items-center justify-center text-center max-sm:scale-90'>
          <img className='w-28 mb-5' src={moneyForm} alt='moneyForm' />
          <p className='font-bold text-2xl mb-4'>Question 5/5</p>
          <p className='font-bold text-lg mb-4'>In 2021, what was your approximate net income, <span className='font-extrabold'>after taxes and deductions</span>, from self-employment?</p>
          <div className='flex flex-col sm:flex-row items-center gap-4'>
            <button onClick={() => { setCurrentPage(currentPage + 1); setTaxCredit('$4,992.23') }} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-36 max-sm:w-40 h-10 rounded-md shadow-full text-white'>Less than $20K</button>
            <button onClick={() => { setCurrentPage(currentPage + 1); setTaxCredit('$14,976.68') }} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-36 max-sm:w-40 h-10 rounded-md shadow-full text-white'>$20K-$50K</button>
            <button onClick={() => { setCurrentPage(currentPage + 1); setTaxCredit('$26,625.22') }} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-36 max-sm:w-40 h-10 rounded-md shadow-full text-white'>$50K-$100K</button>
          </div>
          <div className='flex flex-col sm:flex-row items-center gap-4 mt-4'>
            <button onClick={() => { setCurrentPage(currentPage + 1); setTaxCredit('$29,103.85') }} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-36 max-sm:w-40 h-10 rounded-md shadow-full text-white'>$100K-$145K</button>
            <button onClick={() => { setCurrentPage(currentPage + 1); setTaxCredit('$32,220.00') }} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 w-36 max-sm:w-40 h-10 rounded-md shadow-full text-white'>More than $145K</button>
          </div>
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center text-center'>
          <img className='w-28 mb-5' src={refundForm} alt='refundForm' />
          <p className='font-bold text-xl'>You may be eligible for a tax credit up to</p>
          <p className='text-setcdg font-bold text-3xl'>{taxCredit}</p>
          <p className='font-bold mb-4'>based on your answers</p>
          <p className='text-setcg mb-4'>Start Your Application Today. Submit Your Tax Credits in 5 Business Days or Less!</p>
        </div>
      )}
    </div>
  )
}
